import React from "react";
import "./App.css";
import "antd/dist/antd.min.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Layout } from "antd";
import store from "./redux/store";
import AppRoute from "./components/AppRoute";

const App = () => {
  return (
    <React.Fragment>
      <Provider store={store}>
        <BrowserRouter>
          <Layout>
            <AppRoute />
          </Layout>
        </BrowserRouter>
      </Provider>
    </React.Fragment>
  );
};

export default App;
